import React from 'react';
import {
  shape,
  string,
} from 'prop-types';
import {
  Block,
  Heading,
  Paragraph,
  YoutubeLoader,
} from 'components/common';
import './ResultPageVideoPanel.scss';

const ResultsPageVideoPanel = ({ video }) => (
  <div className="result-page-video-panel" data-selector-type="video-panel">
    <Block>
      <div className="videos-row-wrapper">
        <div className="video-title-wrapper" data-selector-type="title">
          <Heading as="h2">
            {video.heading}
          </Heading>
          <Paragraph>
            {video.subheading}
          </Paragraph>
        </div>
        <div className="video-frame-wrapper" key={video.link} data-selector-type="video">
          <YoutubeLoader className="frame-wrapper" src={video.link} />
        </div>
      </div>
    </Block>
  </div>
);

ResultsPageVideoPanel.defaultProps = {
  video: {},
};

ResultsPageVideoPanel.propTypes = {
  video: shape({
    heading: string.isRequired,
    subheading: string,
    link: string.isRequired,
  }),
};

export default ResultsPageVideoPanel;
